// Api.
import api from './Base';

// Types.
import Tags from '../types/Tags'; // Assuming Tags type is in www/src/types/Tags.ts
import { showError } from '../utils/showAlert';

// Interface for the payload when saving tags (omitting id/tagid as backend will handle it for new tags)
export interface TagToSave {
  datasourceid: number;
  tagname: string;
  tagvalue: string;
}

// Interface for the payload when updating existing tags (includes id)
export interface TagToUpdate {
  id: number;
  datasourceid: number;
  tagname: string;
  tagvalue: string;
}

// Interface for the payload when deleting tags
export interface TagToDelete {
  id: number;
}

const TagApi = {
  getAllRawTags: async (): Promise<Tags[]> => {
    const url = `datasource/tag`; // Corrected: Removed prefix
    let tagsList: Tags[] = [];
    try {
      const response = await api.get<Tags[]>(url);
      if (response?.data) {
        tagsList = response.data;
      }
    } catch (error: any) {
      console.error('Failed to retrieve all raw tags.', error);
      showError('Failed to retrieve all raw tags', error.message || error.toString());
      // Potentially throw the error or return an empty array/handle as per project's error handling strategy
    }
    return tagsList;
  },

  saveTagAssignments: async (tagsToSave: TagToSave[]): Promise<any> => { // Return type can be more specific if API response is known
    const url = `datasource/tag`; // Corrected: Removed prefix
    try {
      const response = await api.post<any>(url, tagsToSave);
      return response.data;
    } catch (error: any) {
      console.error('Failed to save tag assignments.', error);
      showError('Failed to save tag assignments', error.message || error.toString());
      throw error; // Re-throw to be handled by the caller
    }
  },

  updateTagAssignments: async (tagsToUpdate: TagToUpdate[]): Promise<any> => {
    const url = `datasource/tag`; // Corrected: Removed prefix
    try {
      const response = await api.put<any>(url, tagsToUpdate);
      return response.data;
    } catch (error: any) {
      console.error('Failed to update tag assignments.', error);
      showError('Failed to update tag assignments', error.message || error.toString());
      throw error; // Re-throw to be handled by the caller
    }
  },

  deleteTagAssignments: async (tagsToDelete: TagToDelete[]): Promise<any> => { // Return type can be more specific
    const url = `datasource/tag`; // Corrected: Removed prefix
    try {
      // Axios delete method typically sends data in config.data, not as the second argument like post/put
      const response = await api.delete<any>(url, { data: tagsToDelete });
      return response.data;
    } catch (error: any) {
      console.error('Failed to delete tag assignments.', error);
      showError('Failed to delete tag assignments', error.message || error.toString());
      throw error; // Re-throw to be handled by the caller
    }
  },
};

export default TagApi;
